import { Component } from "react";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { MdClose } from "react-icons/md";
import RoundButton from "./RoundButton.jsx";

export default class MessageDialog extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Dialog open={true} sx={{ zIndex: 99999 }}>
                <DialogTitle color="primary" fontSize={12}><b>{this.props.title}</b></DialogTitle>
                <IconButton onClick={e => this.props.onClose()} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent>
                    <Stack width={350}>
                        <Typography variant="caption" mb={2}>{this.props.children}</Typography>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <RoundButton onClick={() => this.props.onConfirm()}>Sim</RoundButton>
                    <RoundButton onClick={() => this.props.onClose()}>Cancelar</RoundButton>
                </DialogActions>
            </Dialog>
        );
    }
}
